export const formatFileName = (fileName) => {
  if (!fileName) return "";

  const parts = fileName.split(".");
  if (parts.length < 2) return fileName; // Handle cases with no extension

  const ext = parts.pop(); // Get the file extension
  const baseName = parts.join("."); // Join in case of multiple dots in filename

  if (baseName.length <= 5) return fileName; // No need to shorten

  return `${baseName.slice(0, 5)}...${ext}`;
};
